<template lang="pug">
  .payment-update-subs-modal
    SectionTitle(text="Update Payment Method").app-modal-title
    p.xs-f-small.max-at-tweak You've updated your default payment method. Would you like to use this payment method for all subscriptions?
    .row(v-for="sub in subsToUpdate" :key="sub.id")
      .row.prod
        .xs-12.prod-info
          p.upper.bold &#183;  {{ sub.products[0].product_name }}
          Pill(v-if="sub.has_extra_tube" text="Extra Tube").ml-10.inline-block

    SubmitButtons(
      submit-text="use this payment method"
      :submit-method="onSubmit"
      cancel-text="no, don't update my other subscriptions",
      :cancel-method="cancel"
      :cancel-link="true"
    )
  
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import SubmitButtons from "../SubmitButtons";
  import SectionTitle from "../SectionTitle";
  import Pill from "../Pill";

  export default {
    name: "PaymentUpdateSubsModal",
    components: {
      Pill,
      SectionTitle,
      SubmitButtons
    },

    computed: {
      ...mapState('payments', [
        'editProfileForm',
        'lastSavedProfile'
      ]),

      ...mapState('subscriptions', [
        'subsToUpdate'
      ])
    },

    methods: {
      ...mapMutations('payments', [
        'setSavingProfile'
      ]),

      ...mapActions('payments', [
        'updatePaymentProfileForSubscriptions',
        'updateLastSavedProfile',
        'getCustomerPaymentProfiles'
      ]),

      ...mapActions('subscriptions', [
        'loadCustomerSubs'
      ]),

      ...mapActions('modal', [
        'hideModal'
      ]),

      onSubmit() {
        let payload = {
          subIds: this.subsToUpdate.map(sub => sub.id),
          paymentProfileId: this.lastSavedProfile.paymentProfileId
        };

        this.setSavingProfile(true);
        return this.updatePaymentProfileForSubscriptions(payload)
          .then(() => {
            this.updateLastSavedProfile({});
            this.loadCustomerSubs();
            //- since we keep subs on payment profile for convenience also need to refresh those
            this.getCustomerPaymentProfiles();
            this.hideModal();
          })
          .finally(() => {
            this.setSavingProfile(false);
          });
      },

      cancel() {
        this.hideModal();
        this.updateLastSavedProfile({});
      }
    }
  }
</script>

<style scoped lang="stylus">
  .payment-update-subs-modal
    > p
      padding-bottom 1em

    .prod
      padding-bottom 1em

    .prod-info
      padding-left 0.5em

      p
        padding-bottom 0.5em

</style>